<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">

                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col min-ht-78">
                    <div class="h-full flex justify-start items-center">
                        <div v-if="token" class="flex-shrink-0 mr-4">
                            <icon-back @click.stop="goBackTo('/jobs')"></icon-back>
                        </div>
                        <div class="flex-grow">
                            <div class="flex items-center text-sm font-light">
                                <router-link to="/dashboard"
                                    class="opacity-50 hover:opacity-100">Dashboard</router-link>
                                <span class="mx-2">/</span>
                                <router-link to="/employment"
                                    class="opacity-50 hover:opacity-100">Employment</router-link>
                                <span class="mx-2">/</span>
                                <div v-if="token">
                                    <router-link to="/jobs" class="opacity-50 hover:opacity-100">Jobs</router-link>
                                    <span class="mx-2">/</span>
                                    <router-link to="/employment/job-request-and-approval"
                                        class="opacity-50 hover:opacity-100">Approvals
                                        Actions</router-link>
                                </div>
                                <div v-else>
                                    <span>Approvals Actions</span>
                                </div>
                            </div>
                            <div class="font-bold">{{ getTitle }}</div>
                        </div>
                    </div>
                </div>

                <div v-if="role == 'admin' || role == 'superadmin' || role == 'careercounselor'"
                    class="mt-8 w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <h1 class="text-base md:text-lg font-semibold">Statistics</h1>
                    <div class="flex items-center flex-wrap">
                        <div class="flex justify-start items-center mr-8">
                            <div>Total Job Applications</div>
                            <div>: {{ !$apollo.queries.jobApplications.loading ? paginatorInfo.total : 0 }}</div>
                        </div>
                        <div class="flex justify-start items-center mr-8">
                            <div>Approved</div>
                            <div>: {{ jobApplicationReport.approved_count }}</div>
                        </div>
                        <div class="flex justify-start items-center mr-8">
                            <div>Rejected</div>
                            <div>: {{ jobApplicationReport.rejected_count }}</div>
                        </div>
                        <div class="flex justify-start items-center mr-8">
                            <div>Not Verified</div>
                            <div>: {{ jobApplicationReport.not_verified_yet_count }}</div>
                        </div>
                    </div>
                </div>

                <div v-if="hasPermission('job-applications-export-excel')" class="mt-4 flex justify-end items-center">
                    <div v-if="isExportExcel"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg hover:text-ternary text-white">
                        <base-spinner-with-text class-list="w-4 h-4" text=""
                            text-class-list="text-white"></base-spinner-with-text>
                        <span class="text-xs">Exporting Excel</span>
                    </div>
                    <div v-else @click="generateReport"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg cursor-pointer hover:text-ternary text-white">
                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                        <span class="text-xs ml-2">Export Excel</span>
                    </div>
                </div>

                <section :class="hasPermission('job-applications-export-excel') ? 'mt-4' : 'mt-8'"
                    class="h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between flex-wrap gap-4">
                        <h1 class="text-base md:text-lg font-semibold">{{ getSubTitle }}</h1>
                        <div v-if="role == 'admin' || role == 'superadmin' || role == 'careercounselor'"
                            class="flex justify-start items-center flex-wrap gap-4">
                            <div v-if="!token" class="w-full sm:w-auto border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Employer:</div>
                                <select v-model="filterByPartner" class="outline-none text-sm w-full sm:w-auto">
                                    <option value="">All Employers</option>
                                    <option :value="item.id" v-for="(item, index) in partnersList" :key="index">{{
                                        item.en_company_name }}</option>
                                </select>
                            </div>

                            <div class="w-full sm:w-auto border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Local or Non Local:</div>
                                <select v-model="filterByLocalOrNonLocal" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="Local">Local</option>
                                    <option value="Non Local">Non Local</option>
                                </select>
                            </div>

                            <div class="w-full sm:w-auto border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Status:</div>
                                <select v-model="filterByStatus" class="outline-none text-sm w-full sm:w-auto">
                                    <option value="">All</option>
                                    <option value="1">Approved</option>
                                    <option value="2">Rejected</option>
                                    <option value="3">Not verified yet</option>
                                </select>
                            </div>

                            <div class="w-full sm:w-auto">
                                <search @on-search="onSearch" class-list="px-4 h-8"></search>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col" v-if="$apollo.queries.jobApplications.loading">
                        <table-shimmer
                            :titleHeaders="['#', 'Student', 'CV', 'Entity', 'Job Title', 'Position', 'Job Offer Close Date', 'Application Date', 'Application Status', 'Note', 'Actions']"
                            :rows="first"></table-shimmer>
                    </div>
                    <div v-else-if="!$apollo.queries.jobApplications.loading && !hasItems"
                        class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No Job Applications found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div v-if="selectedItems.length" class="flex justify-end items-center space-x-2">
                            <button
                                class="bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 disabled:opacity-50 text-xs"
                                @click="bulkApprove(true)" :disabled="selectedItems.length === 0">
                                Approve Selected ({{ selectedItems.length }})
                            </button>
                            <button
                                class="bg-red-600 text-white px-3 py-2 rounded-lg hover:bg-red-700 disabled:opacity-50 text-xs"
                                @click="bulkReject" :disabled="selectedItems.length === 0">
                                Reject Selected ({{ selectedItems.length }})
                            </button>
                        </div>
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">
                                                    <input type="checkbox" v-model="selectAll"
                                                        @change="toggleSelectAll">
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Student</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">CV</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Entity</th>
                                                <th v-if="role == 'admin' || role == 'superadmin'" scope="col"
                                                    class="px-6 py-2 text-gray-400">Employer</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Job Title</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Position</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Job Offer Close Date
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Application Date</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Application Status</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Note</th>
                                                <th v-if="role == 'partner' || role == 'admin' || role == 'superadmin'"
                                                    scope="col" class="px-6 py-2 text-gray-400">Proceed to screen in
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Recruitment Journey</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in items" :key="index"
                                                :class="getClass(item.is_approved)"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="px-6 py-2">
                                                    <input v-if="isShowApproveReject(item.is_approved)" type="checkbox"
                                                        v-model="selectedItems" :value="item.id"
                                                        :disabled="item.is_approved !== null" />
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{
                                                    paginatorInfo.firstItem + index }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div @click.stop="viewStudentProfile(item.user.students.student_id)"
                                                        class="flex items-center cursor-pointer group">
                                                        <div class="flex-shrink-0 mr-3">
                                                            <img class="h-12 w-12 rounded-lg object-cover"
                                                                :src="getProfilePicture(item.user.profile_picture_url, item.user.students.student_id, item.user.students.entity)"
                                                                alt="">
                                                        </div>
                                                        <div class="flex-grow flex flex-col mr-4">
                                                            <h1 class="text-sm font-semibold flex items-center">
                                                                <span class="text-heading group-hover:text-blue-600">{{
                                                                    item.user.name }}</span>
                                                            </h1>
                                                            <p class="text-xs text-gray-400 group-hover:text-blue-400">
                                                                {{ item.user.email }}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div
                                                        v-if="item.user.students.cv == null || item.user.students.cv == ''">
                                                        Not uploaded yet</div>
                                                    <div v-else>
                                                        <span @click="viewCv(item.user.students)"
                                                            class="text-blue-600 hover:underline cursor-pointer">View CV</span>
                                                    </div>
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    getEntityName(item.user.students.entity) }}
                                                </td>
                                                <td v-if="role == 'admin' || role == 'superadmin'"
                                                    class="whitespace-nowrap px-6 py-2">{{ item.job.partner ?
                                                        item.job.partner.en_company_name : item.job.employer_name }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.job.job_title }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.job.position_name }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    formattedDate(item.job.job_close_date) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    formattedDate(item.created_at) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ getStatus(item.is_approved,
                                                    item.job_application_status) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.note }}</td>
                                                <td v-if="role == 'partner' || role == 'admin' || role == 'superadmin' || role == 'careercounselor'"
                                                    class="px-6 py-2">
                                                    <div class="flex"
                                                        v-if="hasPermissionToApproveOrReject(item.job.created_by_user_id)">
                                                        <div v-if="isShowApproveReject(item.is_approved)"
                                                            @click.stop="updateApplication(item.id, true)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-approve
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-approve>
                                                        </div>
                                                        <div v-if="isShowApproveReject(item.is_approved)"
                                                            @click.stop="rejectClicked(item.id)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-reject
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-reject>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-2">
                                                    <div v-if="isShowRecruitmentJourney(item.is_approved)"
                                                        @click.stop="openRecruitmentJourney(item.id)"
                                                        class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                        <icon-document-check
                                                            class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-document-check>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="showAddNote" :title="`Add Your Note`" @close="closeAddNote">
                            <div class="flex flex-col">
                                <label for="note" class="px-8 mt-4 text-sm ml-1">Note</label>
                                <div class="h-32 px-8 rounded-xl mt-2">
                                    <textarea v-model="note"
                                        class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
                                </div>
                                <div class="flex justify-end mt-4 mr-8">
                                    <div @click.stop="addNoteOk"
                                        class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                                        OK</div>
                                </div>
                            </div>
                        </base-modal>
                    </transition>

                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isLoading || isExportExcel">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>

        <transition name="fade" mode="out-in">
            <base-full-modal v-if="showFullModal" title="Student Profile" @close="closeFullModal">
                <student-profile :student-id="studentId"></student-profile>
            </base-full-modal>
        </transition>

        <transition name="fade" mode="out-in">
            <base-full-modal v-if="showRecruitmentJourneyPopUp"
                :title="`Recruitment Journey - ${selectedJobApplication.user.name}`"
                @close="closeRecruitmentJourneyPopUp">
                <recruitment-journey-workflow :job-application="selectedJobApplication"
                    @update="updateJobApplicationStatus"></recruitment-journey-workflow>
            </base-full-modal>
        </transition>

        <transition name="fade" mode="out-in">
            <base-modal v-if="isOpenStudentCvModal" title="View CV" height="70vh" @close="closeStudentCvModal">
                <img v-if="isStudentCvImage" class="h-full w-full object-contain" :src="studentCvPreview" />
                <iframe v-else class="h-full w-full" :src="studentCvPreview"></iframe>
            </base-modal>
        </transition>

    </div>
</template>

<script>
import IconApprove from "../../../../components/icons/IconApprove.vue";
import IconReject from "../../../../components/icons/IconReject.vue";
import IconDocumentCheck from "../../../../components/icons/IconDocumentCheck.vue";
import IconBack from "../../../../components/icons/IconBack.vue";
import gql from 'graphql-tag';
import Pagination from "../../../../components/shared/pagination.vue";
import TableShimmer from '../../../../components/shared/TableShimmer.vue';
import StudentProfile from "../../../student-profile/index.vue";
import RecruitmentJourneyWorkflow from "../recruitment-journey/recruitment-journey-workflow.vue";
import Search from "../../../../components/shared/search.vue";
import xlsx from "xlsx/dist/xlsx.full.min.js";

const BULK_APPROVE_OR_REJECT_JOB_APPLICATIONS_MUTATION = gql`
  mutation BulkApproveOrRejectJobApplications($ids: [ID!]!, $status: Boolean!, $note: String) {
    bulkApproveOrRejectJobApplications(ids: $ids, status: $status, note: $note) {
      error
      message
    }
  }
`;

export default {
    name: "job-request-and-approval-index",
    props: ["token"],
    components: {
        IconApprove,
        IconReject,
        IconDocumentCheck,
        IconBack,
        Pagination,
        TableShimmer,
        StudentProfile,
        RecruitmentJourneyWorkflow,
        Search,
    },
    data() {
        return {
            jobApplications: [],
            first: 10,
            page: 1,
            error: null,
            success: null,
            showAddNote: false,
            note: "",
            selecteId: null,
            isLoading: false,
            showFullModal: false,
            studentId: null,
            filterByPartner: "",
            partnersList: [],
            filterByLocalOrNonLocal: "",
            filterByStatus: "",
            jobApplicationReport: [],
            selectedJobApplication: null,
            selectedJobApplicationId: null,
            showRecruitmentJourneyPopUp: false,
            searchText: "",
            isExportExcel: false,
            isApiCallRecurisive: false,
            generatedReport: [],
            selectAll: false,
            selectedItems: [],
            isOpenStudentCvModal: false,
            studentCvPreview: "",
        };
    },
    watch: {
        jobApplications(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace('/no-permission');
                } else if (newVal.error_code == 401) {
                    this.$router.replace('/');
                } else {
                    alert(newVal.message);
                    this.$router.replace('/');
                }
            }
        },
        filterByPartner() {
            this.page = 1;
            this.getJobApplicationReport();
        },
        filterByStatus() {
            this.page = 1;
            this.getJobApplicationReport();
        },
        filterByLocalOrNonLocal() {
            this.page = 1;
            this.getJobApplicationReport();
        },
        searchText() {
            this.page = 1;
            this.getJobApplicationReport();
        },
        selectedItems(newVal) {
            this.selectAll = newVal.length === this.items.length;
        },
    },
    computed: {
        items() {
            return this.jobApplications.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.jobApplications.paginatorInfo;
        },
        userId() {
            return this.$store.getters.userId;
        },
        role() {
            return this.$store.getters.role;
        },
        getTitle() {
            if (this.token) {
                if (this.$apollo.queries.jobApplications.loading) {
                    const jobApprovalActionsTitle = localStorage.getItem('jobApprovalActionsTitle');
                    if (jobApprovalActionsTitle) {
                        return jobApprovalActionsTitle;
                    } else {
                        return "";
                    }
                } else {
                    const jobApprovalActionsTitle = localStorage.getItem('jobApprovalActionsTitle');
                    if (jobApprovalActionsTitle) {
                        return jobApprovalActionsTitle;
                    } else {
                        if (this.items.length > 0) {
                            const employerName = this.items[0].job.partner ? this.items[0].job.partner.en_company_name : this.items[0].job.employer_name;
                            const dynamicTitle = `${employerName} - ${this.items[0].job.job_title}`;
                            localStorage.setItem('jobApprovalActionsTitle', dynamicTitle);
                            return dynamicTitle;
                        } else {
                            return "";
                        }
                    }
                }
            } else {
                return "Approvals Actions";
            }
        },
        getSubTitle() {
            if (this.token) {
                if (this.$apollo.queries.jobApplications.loading) {
                    return "";
                } else {
                    return `Job Applications List (${this.paginatorInfo.total})`
                }
            } else {
                return "Job Applications List";
            }
        },
        isStudentCvImage() {
            return this.studentCvPreview && this.studentCvPreview.indexOf("data:image/") === 0;
        },
    },
    created() {
        if (this.role == 'admin' || this.role == 'superadmin' || this.role == 'careercounselor') {
            this.getPartnersList();
            this.getJobApplicationReport();
        }
    },
    apollo: {
        jobApplications() {
            return {
                query: gql`query GetAllJobApplications($first: Int!, $page: Int!, $filter_by_partner: Int, $filter_by_status: Int, $token: String, $local_or_non_local: String, $search: String) {
                    jobApplications(first: $first, page: $page, filter_by_partner: $filter_by_partner, filter_by_status: $filter_by_status, token: $token, local_or_non_local: $local_or_non_local, search: $search) {
                        error
                        error_code
                        message
                        data {
                            id
                            user_id
                            job_id
                            is_approved
                            note
                            created_at
                            updated_at
                            user {
                                name
                                email
                                profile_picture_url
                                students {
                                    student_id
                                    entity
                                    cv
                                }
                            }
                            job {
                                id
                                job_title
                                position_name
                                job_close_date
                                partner {
                                    en_company_name
                                }
                                employer_name
                                created_by_user_id
                            }
                            job_application_status {
                                token
                                screened
                                screened_remarks
                                screened_time
                                interviewed
                                interviewed_remarks
                                interviewed_time
                                recruitment_process
                                recruitment_process_remarks
                                recruitment_process_time
                                hired
                                hired_remarks
                                hired_time
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        filter_by_partner: parseInt(this.filterByPartner),
                        filter_by_status: parseInt(this.filterByStatus),
                        token: this.token ? this.token : "",
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        search: this.searchText,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        onSearch(searchText) {
            this.searchText = searchText;
        },
        getEntityName(entity) {
            return entity.replace(/ATHS/g, "ATS");
        },
        getStudentStatus(status, isFinalYear) {
            if (status == 'IG') {
                return 'Alumni';
            } else if (status == 'IG') {
                if (isFinalYear) {
                    return "Senior Student";
                } else {
                    return "Active Student";
                }
            } else {
                return "";
            }
        },
        viewStudentProfile(studentId) {
            this.studentId = studentId;
            this.showFullModal = true;
        },
        closeFullModal() {
            this.showFullModal = false;
            this.studentId = null;
        },
        getClass(isApproved) {
            if (isApproved === true) {
                return "bg-green-100";
            } else if (isApproved === false) {
                return "bg-red-100";
            } else {
                return "";
            }
        },
        getProfilePicture(profilePictureUrl, studentId, entity) {
            if (profilePictureUrl == '/storage/alumni-profile-pictures/default-avatar.jpg') {
                return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
            } else {
                return process.env.VUE_APP_PUBLIC_URL + profilePictureUrl;
            }
        },
        getStatus(status, jobApplicationStatus) {
            if (status === null) {
                return "Pending";
            } else if (status === false) {
                return "Rejected";
            } else {
                if (jobApplicationStatus.hired === null) {
                    if (jobApplicationStatus.recruitment_process === null) {
                        if (jobApplicationStatus.interviewed === null) {
                            if (jobApplicationStatus.screened === null) {
                                return "Proceeded to recruitment journey";
                            } else {
                                if (jobApplicationStatus.screened === true) {
                                    return "Screened In";
                                } else {
                                    return "Not Screened In";
                                }
                            }
                        } else {
                            if (jobApplicationStatus.interviewed === true) {
                                return "Interviewed";
                            } else {
                                return "Not Interviewed";
                            }
                        }
                    } else {
                        if (jobApplicationStatus.recruitment_process === true) {
                            return "In Recruitment Process";
                        } else {
                            return "Not In Recruitment Process";
                        }
                    }
                } else {
                    if (jobApplicationStatus.hired === true) {
                        return "Hired";
                    } else {
                        return "Not hired";
                    }
                }
            }
        },
        isShowApproveReject(status) {
            if (status === null) {
                return true;
            } else {
                return false
            }
        },
        hasPermissionToApproveOrReject(userId) {
            if (this.role == 'partner') {
                return true;
            } else {
                if (this.userId == userId) {
                    return true
                } else {
                    return this.hasPermission('job-request-and-approval-edit');
                }
            }

        },
        isShowRecruitmentJourney(status) {
            if (status === null || status === false) {
                return false;
            } else {
                return true;
            }
        },
        formattedDate(date) {
            if (date) {
                const parsedDate = new Date(date);
                return parsedDate.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).replace(/\//g, '-');
            } else {
                return "";
            }
        },
        setPage(page) {
            this.page = page;
        },
        showToast(message = '') {
            this.$apollo.queries.jobApplications.refetch();
            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'success',
                title: message
            })
            this.closeModal();
        },
        rejectClicked(selecteId) {
            this.selecteId = selecteId;
            this.showAddNote = true;
        },
        closeAddNote() {
            this.showAddNote = false;
            this.note = "";
            this.selecteId = null;
        },
        addNoteOk() {
            this.showAddNote = false;
            if (this.selectedItems.length > 0) {
                this.bulkApprove(false);
            } else {
                this.updateApplication(this.selecteId, false);
            }
        },
        async updateApplication(id, status) {

            this.isLoading = true;

            const UPDATE_MUTATION = gql`
                mutation UpdateJobApplication($id: String!, $status: Boolean!, $note: String) {
                    updateJobApplication(id: $id, status: $status, note: $note) {
                        error
                        message
                    }
                }
            `;

            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_MUTATION,
                    variables: {
                        id: id,
                        status: status,
                        note: this.note,
                    }
                }).then((data) => {
                    if (data.data.updateJobApplication.error) {
                        this.error = data.data.updateJobApplication.message;
                    } else {
                        this.success = data.data.updateJobApplication.message;
                    }
                }).catch((error) => {
                    console.error(error)
                })
            } catch (error) {
                this.error = error.message || "Failed to authenticate, try later.";
            }

            if (this.error === null) {

                this.isLoading = false;

                this.note = "";

                this.$apollo.queries.jobApplications.refetch();

                const Toast = this.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', this.$swal.stopTimer)
                        toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                    }
                })

                if (status) {
                    Toast.fire({
                        icon: 'success',
                        title: 'Application proceeded to recruitment journey!'
                    })
                } else {
                    Toast.fire({
                        icon: 'success',
                        title: 'Application rejected!'
                    })
                }
            } else {

                this.isLoading = false;

                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: this.error,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        this.error = null;
                    }
                })
            }

        },
        hasPermission(crudName) {
            if (this.role == 'superadmin') {
                return true;
            } else {
                const permissions = this.$store.getters.permissions;
                const permissionsArray = permissions.split(",");
                if (permissionsArray.includes(crudName)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        async getPartnersList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GetActivePartnersList {
                            activePartners {
                                data {
                                    id
                                    en_company_name
                                }
                            }
                        }
                    `,
                    fetchPolicy: 'network-only',
                });
                this.partnersList = data.activePartners.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getJobApplicationReport() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GetJobApplicationReport($filter_by_partner: Int, $token: String, $local_or_non_local: String, $filter_by_status: Int, $search: String) {
                            jobApplicationReport(filter_by_partner: $filter_by_partner, token: $token, local_or_non_local: $local_or_non_local, filter_by_status: $filter_by_status, search: $search) {
                                data {
                                    not_verified_yet_count
                                    approved_count
                                    rejected_count
                                }
                            }
                        }
                    `,
                    variables: {
                        filter_by_partner: parseInt(this.filterByPartner),
                        token: this.token ? this.token : "",
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        filter_by_status: parseInt(this.filterByStatus),
                        search: this.searchText,
                    },
                    fetchPolicy: 'network-only',
                });
                this.jobApplicationReport = data.jobApplicationReport.data;
            } catch (error) {
                console.log(error);
            }
        },
        openRecruitmentJourney(id) {
            this.selectedJobApplicationId = id;
            const foundObject = this.items.find(item => item.id === id);

            if (foundObject) {
                this.selectedJobApplication = foundObject;
                this.showRecruitmentJourneyPopUp = true;
            } else {
                console.log("Object not found with id:", id);
            }
        },
        closeRecruitmentJourneyPopUp() {
            this.showRecruitmentJourneyPopUp = false;
            this.selectedJobApplicationId = null;
            this.selectedJobApplication = null;
        },
        async updateJobApplicationStatus() {
            await this.$apollo.queries.jobApplications.refetch();
            this.openRecruitmentJourney(this.selectedJobApplicationId);
        },
        goBackTo(url) {
            this.$router.replace(url);
        },
        getCvUrl(cv_url) {
            let url = "";
            if (cv_url) {
                url = process.env.VUE_APP_PUBLIC_URL + cv_url;
            }
            return url;
        },
        async viewCv(students) {
            if (!students || !students.student_id || !students.cv) return;
            const CV_CONTENT_QUERY = gql`
                query CvContent($student_id: String!) {
                    cvContent(student_id: $student_id) {
                        error
                        error_code
                        message
                        data { content file_type }
                    }
                }
            `;
            try {
                const result = await this.$apollo.query({
                    query: CV_CONTENT_QUERY,
                    variables: { student_id: students.student_id },
                    fetchPolicy: "network-only",
                });
                const response = result.data && result.data.cvContent;
                if (response && !response.error && response.data && response.data.content) {
                    this.studentCvPreview = "data:" + response.data.file_type + ";base64," + response.data.content;
                    this.isOpenStudentCvModal = true;
                } else {
                    const legacyPath = students.cv;
                    if (legacyPath && legacyPath.indexOf("/storage/") === 0) {
                        this.studentCvPreview = process.env.VUE_APP_PUBLIC_URL + legacyPath;
                        this.isOpenStudentCvModal = true;
                    } else {
                        if (this.$swal) {
                            this.$swal.fire({ icon: "error", title: "Error", text: "Unable to load CV." });
                        }
                    }
                }
            } catch (err) {
                if (this.$swal) {
                    this.$swal.fire({ icon: "error", title: "Error", text: "Unable to load CV." });
                }
            }
        },
        closeStudentCvModal() {
            this.isOpenStudentCvModal = false;
            this.studentCvPreview = "";
        },
        async generateReport() {
            var page = 1;
            var limit = 200;
            this.isExportExcel = true;
            this.isApiCallRecurisive = true;
            while (this.isApiCallRecurisive) {
                const responseData = await this.fetchForExporting(page, limit);
                if (responseData.error) {
                    this.$swal
                        .fire({
                            icon: "error",
                            title: "Oops...",
                            text: responseData.message,
                        })
                    break;
                }

                if (responseData.data.length > 0) {
                    this.generatedReport.push(
                        ...responseData.data.map((obj) => {
                            return {
                                student_id: obj.user.students.student_id,
                                student_name: obj.user.name,
                                student_email: obj.user.email,
                                cv_uploaded: obj.user.students.cv ? 'YES' : 'NO',
                                entity: this.getEntityName(obj.user.students.entity),
                                campus: obj.user.students.campus_code,
                                program_name: obj.user.students.program_name,
                                local_or_non_local: obj.user.students.local_or_non_local,
                                student_status: this.getStudentStatus(obj.user.students.student_status, obj.user.students.is_final_year_student),
                                phone: obj.user.students.alumni_phone ? obj.user.students.alumni_phone : obj.user.students.primary_phone,
                                email: obj.user.students.secondary_email ? obj.user.students.secondary_email : obj.user.students.primary_email,
                                gpa: obj.user.students.gpa,
                                employer: obj.job.partner ? obj.job.partner.en_company_name : obj.job.employer_name,
                                job_title: obj.job.job_title,
                                position: obj.job.position_name,
                                job_offer_close_date: this.formattedDate(obj.job.job_close_date),
                                application_date: this.formattedDate(obj.created_at),
                                application_status: this.getStatus(obj.is_approved, obj.job_application_status),
                                note: obj.note
                            };
                        })
                    );
                    page++;
                } else {
                    this.isApiCallRecurisive = false;
                    break;
                }
            }

            if (this.generatedReport.length > 0) {
                let reportName = "Job_Applications";
                if (this.token) {
                    reportName = `${reportName}(${this.getTitle})`;
                }
                this.exportToExcel(reportName);
            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Sorry...',
                    text: 'No data available for this report.',
                })
            }

            this.generatedReport = [];
            this.isExportExcel = false;
            this.isApiCallRecurisive = false;
        },
        async fetchForExporting(pageNo = 1, limitSize = 50) {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query ExportJobApplications(
                            $page: Int
                            $limit: Int
                            $filter_by_partner: Int
                            $filter_by_status: Int
                            $token: String
                            $local_or_non_local: String
                            $search: String
                        )   {
                            exportJobApplications(
                                page: $page
                                limit: $limit
                                filter_by_partner: $filter_by_partner
                                filter_by_status: $filter_by_status
                                token: $token
                                local_or_non_local: $local_or_non_local
                                search: $search
                            )   {
                                    error
                                    error_code
                                    message
                                    data {
                                        id
                                        user_id
                                        job_id
                                        is_approved
                                        note
                                        created_at
                                        updated_at
                                        user {
                                            name
                                            email
                                            profile_picture_url
                                            students {
                                                student_id
                                                entity
                                                campus_code
                                                cv
                                                program_name
                                                local_or_non_local
                                                student_status
                                                is_final_year_student
                                                primary_phone
                                                alumni_phone
                                                secondary_email
                                                primary_email
                                                gpa
                                            }
                                        }
                                        job {
                                            job_title
                                            position_name
                                            job_close_date
                                            partner {
                                                en_company_name
                                            }
                                            employer_name
                                        }
                                        job_application_status {
                                            token
                                            screened
                                            screened_remarks
                                            screened_time
                                            interviewed
                                            interviewed_remarks
                                            interviewed_time
                                            recruitment_process
                                            recruitment_process_remarks
                                            recruitment_process_time
                                            hired
                                            hired_remarks
                                            hired_time
                                        }
                                    }
                                }
                        }
                    `,
                    fetchPolicy: "network-only",
                    variables: {
                        page: pageNo,
                        limit: limitSize,
                        filter_by_partner: parseInt(this.filterByPartner),
                        filter_by_status: parseInt(this.filterByStatus),
                        token: this.token ? this.token : "",
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        search: this.searchText,
                    },
                });

                const responseData = data.exportJobApplications;
                return responseData;
            } catch (error) {
                console.log(error.message);
            }
        },
        exportToExcel(reportName) {
            const XLSX = xlsx;

            let header = [
                "STUDENT ID",
                "STUDENT NAME",
                "STUDENT EMAIL",
                "CV UPLOADED",
                "ENTITY",
                "CAMPUS",
                "PROGRAM NAME",
                "LOCAL OR NON LOCAL",
                "STUDENT STATUS",
                "PHONE",
                "EMAIL",
                "GPA",
                "EMPLOYER",
                "JOB TITLE",
                "POSITION",
                "JOB OFFER CLOSE DATE",
                "APPLICATION DATE",
                "APPLICATION STATUS",
                "NOTE"
            ];

            const worksheet = XLSX.utils.json_to_sheet(this.generatedReport);
            const columnWidths = [];

            for (let i = 0; i < header.length; i++) {
                const column = String.fromCharCode(65 + (i % 26));
                const row = Math.floor(i / 26);
                const columnLetter = row > 0 ? String.fromCharCode(64 + row) + column : column;
                worksheet[`${columnLetter}1`] = { v: header[i], t: "s" };
                columnWidths.push({ width: Math.max(40, header[i].length + 5) });
            }

            worksheet["!cols"] = columnWidths;

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, `${reportName}.xlsx`);
        },
        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedItems = this.items
                    .filter(item => item.is_approved === null)
                    .map(item => item.id);
            } else {
                this.selectedItems = [];
            }
        },
        bulkReject() {
            this.showAddNote = true;
        },
        async bulkApprove(status) {
            this.isLoading = true;
            try {
                const { data } = await this.$apollo.mutate({
                    mutation: BULK_APPROVE_OR_REJECT_JOB_APPLICATIONS_MUTATION,
                    variables: {
                        ids: this.selectedItems,
                        status: status,
                        note: this.note
                    },
                });

                const res = data.bulkApproveOrRejectJobApplications;
                if (res.error) {
                    this.$swal.fire('Error', res.message, 'error');
                } else {
                    this.$swal.fire('Success', res.message, 'success');
                    this.selectedItems = [];
                    this.note = "";
                    this.$apollo.queries.jobApplications.refetch();
                }
            } catch (error) {
                this.$swal.fire('Oops', error.message || 'Something went wrong', 'error');
            } finally {
                this.isLoading = false;
            }
        }
    },
    beforeUnmount() {
        localStorage.removeItem("jobApprovalActionsTitle");
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

@responsive {
    .min-ht-78 {
        min-height: 78px;
    }
}
</style>